import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  ModalContentWrapper,
  CrossButton,
  Cross,
} from '../styles';
import {
  VideoContentWrapper,
  VideoTitle,
  VideoContainer,
  VideoIframe,
} from './styles';

const VideoModal = ({
  isOpen,
  onClose,
  videoUrl,
  videoTitle,
}) => (
  <StyledModal open={isOpen} onClose={onClose}>
    <ModalContentWrapper>
      <CrossButton onClick={onClose}>
        <Cross />
      </CrossButton>
      <VideoContentWrapper>
        <VideoTitle>
          {videoTitle}
        </VideoTitle>
        <VideoContainer>
          <VideoIframe
            src={videoUrl}
            title={videoTitle}
            allowFullScreen
          />
        </VideoContainer>
      </VideoContentWrapper>
    </ModalContentWrapper>
  </StyledModal>
);

VideoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  videoUrl: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
};

export default VideoModal;
